export default {"src":"/_next/static/media/verify-email.8aa31931.svg","height":61,"width":67};